<template>
  <div class="research" style="height: 100%">
    <el-card style="height: 100%">

      <div style="display: flex; height: 100%">
        <div class="research-left" style="height: 100%">
          <div class="research-search">
            <el-cascader
              class="research-select"
              clearable
              v-model="courseIds"
              :show-all-levels="false"
              :props="subjectTreeProps"
              placeholder="请输入所属科目"
              :options="subjectTreeList"
              @change="subjectSearchChange"
            ></el-cascader>
            <el-cascader
              collapse-tags
              style="width: 100%; margin-top: 10px"
              v-model="campusId"
              :show-all-levels="false"
              :props="campusTreeProps"
              placeholder="请选择所属校区"
              :options="campusList"
              @change="campusSearchChange"
              clearable
            ></el-cascader>
            <el-select
              style="width: 100%; margin-top: 10px"
              v-model="classInfoId"
              clearable
              filterable
              placeholder="请选择班级"
              @change="optionsChange"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <div v-if="ChapterTree.length > 0" style="margin-top: 10px">
              <div class="jc-sb">
                <div class="plan-name">
                  {{ planName }}
                </div>
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scheduleSettingSearchForm.planId"
                  @click="showscheduleDialog"
                  v-auth="
                    'classRoomTeaching_/scheduleInfo/batchCopyCourseByClassInfo'
                  "
                  >同步</el-button
                >
              </div>

              <div v-for="(item, index) in ChapterTree" :key="index">
                <div
                  :class="scheduleInfoId == item.id ? 'chapterTree-names' : ''"
                  class="chapterTree-name"
                  @click="chooseIds(item.id)"
                >
                  第{{ index + 1 }}课时
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="research-right">
          <!-- <div class="custom-tabpane" @click="studentOverview">学员概况</div>
          <div class="custom-tabpane studentPreview" @click="classOverview">班级概况</div> -->
           <el-button class="signbtn" @click="redirectTo('/signInGeneral','homeWorkLog')">做题概况</el-button>
           <el-button class="signbtn" @click="redirectTo('/signInGeneral','signInLog')">签到概况</el-button>

          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              label="签到情况"
              :key="siginTitle.sign"
              name="签到情况"
              class="tab-type"
            >
              <div class="signIn">
                <div class="signIn-title">
                  <div class="num-box">
                    <span class="num-title">已签到(人)</span>
                    <!--{{}}  signNum-->
                    <div style="color: #24d2b5" class="num-num">
                      {{ siginTitle.sign }}
                    </div>
                  </div>
                  <div class="num-box">
                    <span class="num-title">未签到(人)</span>
                    <!--notsignNum  -->
                    <span style="color: #455a64" class="num-num">{{
                      siginTitle.notSign
                    }}</span>
                  </div>
                  <div class="num-box">
                    <span class="num-title">补签到(人)</span
                    ><!-- supsignNum -->
                    <span style="color: #ffc349" class="num-num">{{
                      siginTitle.supSign
                    }}</span>
                  </div>
                  <div class="num-box">
                    <span class="num-title">签到率</span>
                    <!--statisticsNum v-if="siginTitle.statistics" -->
                    <div class="num-num" style="color: #24d2b5">
                      <span style="font-size: 24px">{{
                        siginTitle.statistics
                      }}</span>
                      <span
                        v-if="siginTitle.statistics"
                        style="font-size: 14px; margin-left: -5px"
                        >%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin-top: 20px">
                <div style="text-align: right; margin-bottom: 10px">
                  <el-button
                    type="primary"
                    @click="exportSignInLog()"
                    v-auth="'classRoomTeaching_/signInLog/exportExcel'"
                    >导出签到记录</el-button
                  >
                </div>
                <el-table
                  :data="signInData.data"
                  border
                  style="width: 100%"
                  v-auth="'classRoomTeaching_/classInfoStudent/signList'"
                >
                  <el-table-column
                    prop="student.name"
                    label="学员姓名"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="student.account"
                    label="学员电话"
                    :show-overflow-tooltip="true"
                  >
                    <!-- <template slot-scope="scope">
                      <span style="color: #459FFC" v-if="scope.row.student" @click="showRecord(scope.row.student)">{{scope.row.student.account}}</span>
                    </template>   -->
                  </el-table-column>
                  <el-table-column
                    prop="source"
                    label="签到状态"
                    :show-overflow-tooltip="true"
                    :render-header="renderSpecNameHeader"
                  >
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.signState == 1"
                        style="color: #32d3b5"
                        >已签到</span
                      >
                      <span
                        v-if="scope.row.signState == 3"
                        style="color: #c3b2c2"
                        >未签到</span
                      >
                      <span
                        v-if="scope.row.signState == 2"
                        style="color: #fec255"
                        >补签到</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="signTime"
                    label="签到时间"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <!-- 回访备注 -->
                  <el-table-column label="回访备注">
                    <template slot-scope="scope">
                      <el-input
                        maxlength="100"
                        ref="inputIndex"
                        autofocus="true"
                        @blur="confirmEdit(scope.row)"
                        v-model="scope.row.signInRemark.signRemark"
                        type="text"
                        placeholder="请输入备注"
                        size="mini"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-auth="'classRoomTeaching_/classInfoStudent/signList'"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :page-sizes="[10, 20, 30, 40]"
                  style="margin-top: 20px; text-align: right"
                  :total="signInData.total"
                  :page-size="signInData.pageSize"
                  :current-page="signInData.pageNumber"
                  @size-change="signInSizeChange"
                  @current-change="signInPageChange"
                ></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane label="学习资料" name="学习资料" class="tab-type">
              <div>
                <el-button
                  type="primary"
                  @click="materialDialog = true"
                  v-auth="
                    'classRoomTeaching_/chapterMaterials/addChapterMaterials'
                  "
                  >添加学习资料</el-button
                >
                <el-table
                  v-auth="
                    'classRoomTeaching_/classCourseDetail/chapterMaterialsList'
                  "
                  :data="chapterMaterialsAttachment"
                  border
                  style="width: 100%; margin-top: 20px"
                >
                  <el-table-column
                    prop="name"
                    label="名称"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <i
                        :class="'iconfont ' + setIcon(scope.row.name)"
                        :style="
                          'font-size: 16px;;color:' + setColor(scope.row.name)
                        "
                      ></i>
                      <span
                        >{{ scope.row.name }}
                        <el-tag
                          v-if="
                            scope.row.courseType == 2 &&
                            scope.row.customizeBlock
                          "
                          >自建</el-tag
                        >
                        <el-tag
                          type="warning"
                          v-if="
                            scope.row.courseType == 1 &&
                            scope.row.customizeBlock
                          "
                          >同步</el-tag
                        >
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="类型"
                    :show-overflow-tooltip="true"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.customizeBlock">自定义</span>
                      <span v-else>标准</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="大小"
                    width="150px"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <span
                        >{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="state"
                    label="操作"
                    width="80px"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <!-- <i
                        style="font-size:16px;margin-right:10px"
                        class="el-icon-tickets mainColor"
                        @click="openView(scope.row.url,scope.row.name)"
                      ></i> -->
                      <i
                        v-auth="'classRoomTeaching_flieDown'"
                        style="font-size: 16px; margin-right: 10px"
                        class="el-icon-bottom mainColor"
                        @click="flieDown(scope.row.url)"
                      ></i>
                      <i
                        v-auth="
                          'classRoomTeaching_/chapterMaterials/deleteChapterMaterials'
                        "
                        v-if="
                          scope.row.customizeBlock && scope.row.courseType == 2
                        "
                        style="font-size: 16px"
                        class="el-icon-delete mainColor"
                        @click="flieDelete(scope.row.id)"
                      ></i>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <el-pagination
                  background
                  layout="prev, pager, next, jumper,  total, sizes"
                  style="margin-top: 20px;text-align: left;"
                  :total="handoutsData.total"
                  :page-size="handoutsData.pageSize"
                  :page-sizes="[10, 20, 30, 40]"
                  :current-page="handoutsData.pageNumber"
                  @size-change="handoutsDataSizeChange"
                  @current-change="handoutsDataCurrentChange"
                ></el-pagination> -->
              </div>
            </el-tab-pane>

            <el-tab-pane label="课堂练习" name="课堂练习" class="tab-type">
              <template v-if="scheduleInfoId && classInfoId">
                <el-button
                  size="small"
                  type="primary"
                  @click="updateQuestion()"
                  v-auth="'classRoomTeaching_updateQuestion'"
                  >新建课堂练习</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  @click="addDefaultQuestion()"
                  v-auth="
                    'classRoomTeaching_/classCourseDetail/copyDefaultChapterMaterials'
                  "
                  >添加标准练习</el-button
                >
              </template>
              <div v-for="item in practiceList" :key="item.id">
                <div class="zhao-between" style="margin-top: 20px">
                  <div style="font-size: 16px; color: #455a64">
                    {{ item.sequenceName }}
                    <span
                      v-if="item.active == 1"
                      style="
                        font-size: 13px;
                        padding: 2px 4px;
                        taxt-align: center;
                        line-height: 20px;
                        background-color: rgba(255, 177, 2, 1);
                        color: #fff;
                      "
                      >未开始</span
                    >
                    <span
                      v-if="item.active == -1"
                      style="
                        font-size: 13px;
                        padding: 2px 4px;
                        taxt-align: center;
                        line-height: 20px;
                        background-color: #57bf9a;
                        color: #fff;
                      "
                      >练习中</span
                    >
                    <span
                      v-if="item.active == -2"
                      style="
                        font-size: 13px;
                        padding: 2px 4px;
                        taxt-align: center;
                        line-height: 20px;
                        background-color: rgba(162, 170, 188, 1);
                        color: #fff;
                      "
                      >已结束</span
                    >
                    <el-tag type="warning" v-if="item.courseType == 1"
                      >同步</el-tag
                    >
                    <el-tag v-else>自建</el-tag>
                  </div>
                  <div>
                    <span v-if="item.active == 1">
                      <el-button
                        size="small"
                        @click="updateQuestion(item.id)"
                        v-auth="'classRoomTeaching_updateQuestion'"
                        >添加题目</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        @click="startPractice(item)"
                        v-auth="'classRoomTeaching_/practice/active'"
                        >开始练习</el-button
                      >
                    </span>
                    <span v-if="item.active == -1">
                      <el-button size="small" type="text">{{
                        showTime
                      }}</el-button>
                      <el-button
                        size="small"
                        type="primary"
                        @click="stopPractice(item)"
                        >结束练习</el-button
                      >
                    </span>
                    <span v-if="item.active == -2">
                      <el-button
                        size="small"
                        type="primary"
                        v-auth="'classRoomTeaching_openRankingListDialog'"
                        @click="openRankingListDialog(item.id)"
                        >练习排行</el-button
                      >
                    </span>
                    <span>
                      <i
                        v-if="item.courseType == 2"
                        v-auth="
                          'classRoomTeaching_/practice/deletePracticeById'
                        "
                        @click.stop="deleteClassCourseDetail(item.id)"
                        class="el-icon-delete mainColor"
                        title="删除"
                      ></i>
                    </span>
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <el-table
                    :data="item.questionList"
                    border
                    style="width: 100%"
                    row-key="id"
                  >
                    <el-table-column
                      prop="name"
                      label="排序"
                      width="60"
                      align="center"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="questionTypeName"
                      label="题型"
                      width="100"
                      :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="title"
                      label="题干"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <span v-html="scope.row.title">大题</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="answer"
                      label="答案"
                      width="80"
                      :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                      prop="correctPercent"
                      label="正确率"
                      width="80"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <span v-if="item.active == -2 && scope.row.big != 1"
                          >{{ scope.row.correctPercent }}%</span
                        >
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="id"
                      label="详情"
                      width="80"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <span
                          v-if="item.active == -2 && scope.row.big != 1"
                          style="color: #24d2b5"
                          @click="resultDialogEvent(item.id, scope.row.id)"
                          >查看</span
                        >
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="课后作业" name="课后作业" class="tab-type">
              <homework
                :homeworkData="homeworkData"
                v-if="activeName == '课后作业'"
              ></homework>
            </el-tab-pane>

            <el-tab-pane label="课程视频" name="课程视频" class="tab-type">
              <videoInfo
                v-if="activeName == '课程视频'"
                :scheduleInfoId="scheduleInfoId"
                @videoListChange="videoListChange"
                @deleteVideo="deleteVideo"
                @updateAttachment="updateAttachment"
                @selectionVideoChange="selectionVideoChange"
                :videoList="videoList"
              ></videoInfo>
              <div style="display: flex; justify-content: space-between">
                <div style="display: flex; margin-top: 20px; padding: 2px">
                  <div
                    style="line-height: 28px; color: #a2aabc; margin-left: 20px"
                  >
                    已选{{ ids.length }}条
                  </div>
                  <div
                    class="photoMaterial-button"
                    @click="delectVideoList()"
                    v-auth="
                      'classRoomTeaching_/attachmentObject/deleteAttachmentRecording'
                    "
                  >
                    批量删除
                  </div>
                  <!-- <div class="photoMaterial-button" @click="selectTransferFodder(1)">移动到</div> -->
                  <!-- <div class="photoMaterial-button" @click="selectTransferFodder(2)">全部移动到</div> -->
                </div>
                <el-pagination
                  v-auth="
                    'classRoomTeaching_/attachmentObject/recordingPageList'
                  "
                  background
                  layout="prev, pager, next, jumper,  total"
                  style="margin-top: 20px; text-align: left"
                  :total="videoParams.total"
                  :page-size="videoParams.pageSize"
                  @current-change="videoPageChange"
                ></el-pagination>
              </div>
              <!-- :current-page="videoParams.pageNumber" -->
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-card>

    <el-dialog
      title="从题库选择"
      :visible.sync="examDialog"
      :close-on-click-modal="false"
      width="70%"
    >
      <question
        v-if="examDialog"
        :courseId="searchForm.courseId"
        @sentMsg="getMsg"
      ></question>
    </el-dialog>

    <el-dialog
      title="练习排行榜"
      :visible.sync="rankingListDialog"
      :close-on-click-modal="false"
      width="500px"
    >
      <rankingList v-if="rankingListDialog" :typeId="typeId"></rankingList>
    </el-dialog>

    <el-dialog
      title="选择讲义"
      :visible.sync="materialDialog"
      :close-on-click-modal="false"
      width="70%"
    >
      <material @materialChange="materialChange"></material>
    </el-dialog>

    <el-dialog
      title="查看文件"
      :visible.sync="viewDialog"
      :close-on-click-modal="false"
      style="height: 90%"
      width="70%"
    >
      <iframe
        v-if="viewUrl.indexOf('officeapps') != -1"
        :src="viewUrl"
        width="100%"
        height="600px"
        frameborder="1"
      ></iframe>
      <iframe
        v-else
        :src="viewUrl"
        width="100%"
        height="600px"
        frameborder="1"
      ></iframe>
    </el-dialog>
    <el-dialog
      title="查看详情"
      :visible.sync="resultDialog"
      :close-on-click-modal="true"
      width="70%"
    >
      <div class="dashboard-show-data" id="myChart"></div>
      <div>
        <div style="font-size: 18px; color: #455a64; margin: 20px 0">
          正确率：{{ chapterMaterialsDetailByQuestionIdList.correctPercent }}%
        </div>
        <el-table
          :data="chapterMaterialsDetailByQuestionIdList.dataMapList"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="结果"
            width="100px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="count"
            label="数量"
            width="100px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="studentNameList"
            label="学员列表"
            :show-overflow-tooltip="false"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 同步框 -->
    <transfer
      ref="transfer"
      @getCopyList="getCopyList"
      :transferSetting="transferSetting"
      :tableColums="tableColums"
    >
      <el-row :gutter="20" style="margin-bottom: 30px">
        <el-col :sm="12" :md="5" :lg="5">
          <el-cascader
            collapse-tags
            style="width: 100%"
            v-model="scheduleSettingSearchForm.campusIds"
            :show-all-levels="false"
            :props="transferCampusTreeProps"
            placeholder="请选择所属校区"
            :options="campusList"
            clearable
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="5" :lg="5">
          <el-cascader
            style="width: 100%"
            clearable
            v-model="scheduleSettingSearchForm.subjectCourseId"
            :show-all-levels="false"
            :props="transSubjectTreeProps"
            placeholder="请选择所属科目"
            :options="subjectTreeList"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="4" :lg="4">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="
              scheduleSettingSearchForm.pageNumber = 1;
              getScheduleClassInfoList();
            "
            >查询</el-button
          >
        </el-col>
      </el-row>
    </transfer>
  </div>
</template>

<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import question from "../common/question";
import homework from "./homework";
import videoInfo from "./video";
import rankingList from "./rankingList";
import material from "../common/material";
import SelectHeader from "./SelectHeader";
import { scheduleSetting } from "./mixin/scheduleSetting";
import transfer from "./transfer.vue";
export default {
  filters: {},
  components: {
    question,
    homework,
    videoInfo,
    material,
    rankingList,
    SelectHeader,
    transfer,
  },
  mixins: [scheduleSetting],
  data() {
    return {
      chooseId:undefined,
      campusId: undefined,
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      campusList: [],
      remarks: "",
      index: -1,
      student: {},
      fullscreenLoading: false,
      siginListTitle: "",
      siginListDialog: false,
      // 假数据
      siginList: [
        {
          classTime: "第一课时",
          siginState: 1,
          remarks: "回访记录",
        },
      ],
      ids: [],
      siginTitle: {
        sign: null,
        notsign: null,
        supsign: null,
        statistics: null,
      },
      videoParams: {
        scheduleInfoId: "",
        pageSize: 10,
        pageNumber: 1,
        total: 0,
      },
      videoList: [],
      homeworkBlock: true,
      chapterMaterials: [],
      practiceList: [],
      chapterMaterialsId: "",
      materialsId: null,
      examDialog: false,
      rankingListDialog: false,
      materialDialog: false,
      viewDialog: false,
      viewUrl: "",
      classInfoId: "",
      resultDialog: false,
      planName: "教学课程",
      colorList: {
        img: {
          color: "rgb(232, 145, 49)",
          icon: "icon-png",
        },
        txt: {
          color: "rgb(51, 51, 51)",
          icon: "icon-text",
        },
        mp4: {
          color: "rgb(243, 177, 55);",
          icon: "icon-mp1",
        },
        mp3: {
          color: "rgb(241, 109, 0);",
          icon: "icon-mp",
        },
        none: {
          color: "",
          icon: "icon-wukong",
        },

        pdf: {
          color: "rgb(220,46,27)",
          icon: "icon-xlsx",
        },
        docx: {
          color: "rgb(58,128,252)",
          icon: "icon-docx",
        },
        ppt: {
          color: "rgb(243,78,25)",
          icon: "icon-pdf",
        },
        xlsx: {
          color: "rgb(3,158,25)",
          icon: "icon-pdf",
        },
      },
      handoutsData: {
        data: [],
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      signInData: {
        data: [],
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      typeId: "",
      options: [],
      courseIds: [],
      startBeginTime: "",
      type: 2,
      treeArr:[],
      campusName:'',
      subjectTreeList: [],
      activeName: "签到情况",
      ChapterTree: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      searchForm: {},
      startInterval: null,
      showTime: null,
      signData: {
        signCount: null,
      },
      scheduleInfoId: "",
      chapterMaterialsAttachment: [],
      chapterMaterialsDetailByQuestionIdList: [],
      homeworkData: {
        classInfoId: null,
        scheduleInfoId: null,
        courseId: null,
      },
      signType: 0,
      signNum: 0,
      notsignNum: 0,
      supsignNum: 0,
      statisticsNum: 0,
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
    /* campusArr(){
    const result= this.treeToArr(this.campusList)
   const item= result.find(item=>item.id==this.campusId)
   //console.log('123',item.name);
   return item.name
    } */
  },
  watch: {
    notsignNum(val) {
      console.log(val);
    },
  /* chooseId(val){
    console.log(val);
const item=this.treeArr.find(item=>item.id==val)
this.campusName=item.name
console.log(this.campusName);
  } */
  },
  destroyed() {
    // clearInterval(this.startInterval);
  },
  methods: {
    treeToArr(treeArr){
       const arr= JSON.parse(JSON.stringify(treeArr))
      let result=[]
      for(let i of arr){
      const item= JSON.parse(JSON.stringify(i))
      delete item.children
      result.push(item)
      if(Array.isArray(i.children) && i.children.length>0){

      result=result.concat(this.treeToArr(i.children))


}
      }
     // console.log(result);
      return result
    },
    redirectTo(path,type){
      if(!this.classInfoId) return this.$message.warning('请先选择班级')
      this.$router.push({path,query:{
        classInfoId:this.classInfoId,
        type,
        planName:this.planName,
        campusName:this.campusName
      }})
    },//跳转
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
           this.treeArr=this.treeToArr(this.campusList)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    studentOverview() {
      this.$router.push({ path: "/studentOverview" });
    },
    classOverview() {
      this.$router.push({ path: "/classOverview" });
    },
    exportSignInLog() {
      this.loading = true;
      this.api.signInLog
        .exportSignInLog({
          classInfoId: this.classInfoId,
          scheduleInfoId: this.scheduleInfoId,
          type: 0,
          className: this.planName
        })
        .then((result) => {
          if(result.success){
            location.href = result.data;
            this.loading = false;
          }else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    confirmEdit(row) {
      if (
        row.signInRemark.signRemark != "" &&
        row.signInRemark.signRemark != null
      ) {
        this.api.classroom
          .addSignRemark({
            id: row.signInRemark.id,
            signRemark: row.signInRemark.signRemark,
            studentId: row.studentId,
            scheduleInfoId: this.scheduleInfoId,
          })
          .then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.message);
            }
          });
      }
    },
    // 打开提示框 查看所有签到记录和回访记录 发送网络请求 获取签到数据
    showRecord(student) {
      this.siginListTitle = student.name + " 的签到记录";
      this.siginListDialog = true;
    },
    // 失去加点事件 将输入框转去掉 并发送网路请求
    changeBtn() {
      this.student.remarks = this.remarks;
      // 发送修改备注的网络请求，请求成功之后 重新获取数据
      this.signInData.data[this.index].student = this.student;
      this.index = -1;
      this.student = {};
      this.remarks = "";
      // 发送网络请求
    },
    //做题时长
    startShowTime() {
      let beginTime = "2020-09-26 09:08:09";
      let nowTime = new Date().getTime();
      //获取时间差
      let timediff = Math.round(
        (nowTime - new Date(beginTime.replace(/-/g, "/")).getTime()) / 1000
      );
      //获取还剩多少小时
      let hour = parseInt((timediff / 3600) % 24);
      //获取还剩多少分钟
      let minute = parseInt((timediff / 60) % 60);
      //获取还剩多少秒
      let second = timediff % 60;
      return hour + ":" + minute + ":" + second;
    },
    renderSpecNameHeader(createElement, { column, $index }) {
      let self = this;

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    // 根据签到状态查看签到列表
    selectChange(val) {
      if (val == "") {
        // console.log(123);
        this.signType = 0;
        this.pageList();
      } else if (val == "未签到") {
        // console.log("未签到");
        this.signType = 3;
        this.pageList();
      } else if (val == "已签到") {
        // console.log("已签到");
        this.signType = 1;
        this.pageList();
      } else {
        // console.log("补签到");
        this.signType = 2;
        this.pageList();
      }
    },
    chooseIds(id) {
      this.scheduleInfoId = id;
      this.videoParams.scheduleInfoId = this.scheduleInfoId;
      this.homeworkData.scheduleInfoId = id;
      // console.log(this.videoParams);
      // this.handleClick();
    },
    // 上传视频
    videoListChange(ids) {
      if (this.scheduleInfoId == "") {
        this.$message.error("请先选择课程");
        return;
      }
      let attachments = [];
      for (let item of ids) {
        attachments.push({ id: item.id });
      }
      console.log("scheduleInfoId", ids);
      let data = {
        scheduleInfoId: this.scheduleInfoId,
        attachments,
      };
      this.api.videoMaterials.addAttachmentRecording(data).then((res) => {
        if (res.code === 200) this.getVideoList();
        else this.$message.error(res.message);
      });
    },
    updateAttachment(data) {
      this.api.videoMaterials.updateAttachment(data).then((res) => {
        if (res.code === 200) {
          this.getVideoList();
          this.$message.success("操作成功");
        } else this.$message.error("操作失败");
      });
    },
    deleteVideo(data) {
      this.pubDeleteVideo([{ id: data.id }]);
    },
    // 批量删除
    delectVideoList() {
      this.pubDeleteVideo(this.ids);
    },
    // 删除公共接口
    pubDeleteVideo(data) {
      this.$confirm("确定删除该视频？", "系统消息", { type: "warning" }).then(
        () => {
          this.api.videoMaterials
            .deleteAttachmentRecording(data)
            .then((res) => {
              if (res.code === 200) {
                this.getVideoList();
                this.$message.success("操作成功");
              } else this.$message.error("操作失败");
            });
        }
      );
    },
    selectionVideoChange(ids) {
      this.ids = ids;
      console.log(this.ids);
    },
    // 获取视频列表
    getVideoList(videoParams) {
      if (this.scheduleInfoId) {
        this.api.videoMaterials
          .recordingPageList(videoParams ? videoParams : this.videoParams)
          .then((video) => {
            if (video.code === 200) {
              this.videoList = video.data.records;
              this.videoParams.pageSize = video.data.size;
              this.videoParams.total = video.data.total;
            } else this.$message.error(res.message);
          });
      } else {
        this.videoList = [];
      }
    },
    videoPageChange(val) {
      console.log(val);
      let videoParams = this.videoParams;
      videoParams.pageNumber = val;
      this.getVideoList(videoParams);
    },
    resultDialogEvent(id, questionId) {
      let loading = this.$loading.service({
        text: "请稍等",
        target: document.querySelector(".research-right"),
      });
      this.fullscreenLoading = true;
      this.chapterMaterialsDetailByQuestionIdList = [];
      var obj = {
        id: id,
        questionId: questionId,
      };
      this.api.signInLog
        .chapterMaterialsDetailByQuestionId(obj)
        .then((result) => {
          if (result.success) {
            console.log(result);
            this.chapterMaterialsDetailByQuestionIdList = result.data;
            setTimeout(() => {
              this.drawLine(loading);
            });
            this.resultDialog = true;
          } else {
            this.$message.error(result.message);
          }
        });
    },
    drawLine(loading) {
      let chartMapList =
        this.chapterMaterialsDetailByQuestionIdList.chartMapList;
      let legendList = [];
      let seriesList = [];
      let correctColor = "rgb(36, 210, 181)";
      let errorColor = "rgb(255,85,85)";
      // console.log(chartMapList)
      let legend = chartMapList.legend;
      for (let i = 0; i < legend.length; i++) {
        legendList.push(legend[i].name);
        let color = errorColor;
        if (legend[i].isCorrect == 1) {
          color = correctColor;
        }
        seriesList.push({
          name: legend[i].name,
          type: "bar",
          barWidth: 60,
          data: legend[i].value,
          itemStyle: {
            normal: {
              color: color,
            },
          },
        });
      }
      // console.log(legendList)
      // console.log(seriesList)

      let myChart = echarts.init(document.getElementById("myChart"));
      myChart.setOption(
        {
          tooltip: {},
          xAxis: {
            data: chartMapList.x,
          },
          yAxis: {},
          legend: {
            x: "center",
            y: "bottom",
            data: legendList,
          },
          series: seriesList,
          // [
          //   {
          //     name: "正确答案",
          //     type: "bar",
          //     barWidth: 60,
          //     data: [5, 0, 0, 0],
          //     itemStyle: {
          //       normal: {
          //         color: "rgb(36, 210, 181)"
          //       }
          //     }
          //   },
          //   {
          //     name: "错误答案",
          //     type: "bar",
          //     barWidth: 60,
          //     data: [0, 20, 36, 10],
          //     itemStyle: {
          //       normal: {
          //         color: "rgb(255,85,85)"
          //       }
          //     }
          //   }
          // ]
        },
        true
      );
      loading.close();
    },
    updateQuestion(id) {
      if (this.scheduleInfoId) {
        this.chapterMaterialsId = id;
        this.examDialog = true;
      } else {
        this.$message.error("请先选择课时");
      }
    },
    addPracticeQuestionForSchedule(questionIds) {
      let obj = {
        scheduleInfoId: this.scheduleInfoId,
        classInfoId: this.classInfoId,
        questionList: questionIds,
        type: 1,
      };

      let batchChapterMaterialsForPlanApi = "addPracticeQuestionForSchedule";
      if (this.chapterMaterialsId) {
        batchChapterMaterialsForPlanApi = "updatePracticeQuestionForSchedule";
        obj.id = this.chapterMaterialsId;
      }
      this.api.practice[batchChapterMaterialsForPlanApi](obj).then((result) => {
        if (result.success) {
          this.$message.success(result.message);
          this.getPracticeListByScheduleId(1);
          this.chapterMaterialsId = "";
          this.examDialog = false;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    startPractice(item) {
      this.api.practice
        .active({
          id: item.id,
          active: -1,
        })
        .then((result) => {
          if (result.success) {
            this.$message.success(result.message);
            let time = new Date();
            // this.startInterval = setInterval(() => {
            //   let timeNow = new Date();
            //   this.showTime = this.countOnFun(time.getTime());
            // }, 1000);
            this.getPracticeListByScheduleId(1);
          } else {
            this.$message.error(result.message);
          }
        });
    },
    //获取练习排行
    openRankingListDialog(id) {
      this.typeId = id;
      this.rankingListDialog = true;
    },
    stopPractice(item) {
      this.api.practice
        .active({
          id: item.id,
          active: -2,
        })
        .then((result) => {
          if (result.success) {
            this.$message.success(result.message);
            // clearInterval(this.startInterval);
            this.showTime = null;
            this.getPracticeListByScheduleId(1);
          } else {
            this.$message.error(result.message);
          }
        });
    },
    getMsg(val) {
      let arr = [];
      this.practiceList.forEach((e) => {
        if (e.id == this.chapterMaterialsId) {
          e.questionList.forEach((item) => {
            arr.push({ id: item.id });
          });
        }
      });
      val.forEach((e) => {
        let d = true;
        arr.forEach((item) => {
          if (item.id == e.id) {
            d = false;
          }
        });
        if (d) {
          arr.push({ id: e.id });
        }
      });
      console.log(this.practiceList);
      this.addPracticeQuestionForSchedule(arr);
    },
    flieDown(url) {
      window.open(url);
    },
    flieDelete(id) {
      this.$confirm("确定删除该讲义？", "系统消息", { type: "warning" }).then(
        () => {
          let obj = { id: this.materialsId, attachments: [{ id: id }] };
          this.api.chapterMaterials
            .deleteChapterMaterials([obj])
            .then((result) => {
              if (result.success) {
                this.chapterMaterialsList(1);
              } else {
                this.$message.error(result.message);
              }
            });
        }
      );
    },
    setIcon(val) {
      let str = val.toString().split(".");
      let arr = ["png", "jpg", "jpeg", "gif", "ico"];
      if (arr.indexOf(str[str.length - 1]) != -1) {
        str[str.length - 1] = "img";
      }
      if (this.colorList[str[str.length - 1]]) {
        return this.colorList[str[str.length - 1]].icon;
      } else {
        return this.colorList.none.icon;
      }
    },
    setColor(val) {
      let str = val.toString().split(".");
      let arr = ["png", "jpg", "jpeg", "gif", "ico"];
      if (arr.indexOf(str[str.length - 1]) != -1) {
        str[str.length - 1] = "img";
      }

      if (this.colorList[str[str.length - 1]])
        return this.colorList[str[str.length - 1]].color;
      else {
        return this.colorList.none.color;
      }
    },

    getPracticeListByScheduleId(type) {
      this.practiceList = [];
      if (this.scheduleInfoId) {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".research-right"),
        });
        this.api.practice
          .getPracticeListByScheduleId({
            type: type,
            scheduleInfoId: this.scheduleInfoId,
            classInfoId: this.classInfoId,
          })
          .then((result) => {
            // this.chapterMaterialsAttachment = [];
            // if(result.data.chapterMaterialsAttachment!=null){
            //   result.data.chapterMaterialsAttachment.forEach(e => {
            //     this.$set(e,'customizeBlock',false)
            //     this.chapterMaterialsAttachment.push(e)
            //   });
            // }
            // if(result.data.chapterMaterialsAttachment!=null){
            //   result.data.chapterMaterialsListAttachment.forEach(e => {
            //     this.$set(e,'customizeBlock',true)
            //     this.chapterMaterialsAttachment.push(e)
            //   });
            // }
            this.materialsId = result.data.chapterMaterialsId;
            // this.chapterMaterialsAttachment = result.data.chapterMaterialsAttachment;
            this.practiceList = result.data;
            console.log(this.practiceList);
            loading.close();
          })
          .catch((error) => {
            console.log(error);
            loading.close();
          });
      }
    },

    chapterMaterialsList(type) {
      this.chapterMaterials = [];
      if (this.scheduleInfoId) {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".research-right"),
        });
        this.api.chapterMaterials
          .chapterMaterialsList({
            type: type,
            scheduleInfoId: this.scheduleInfoId,
            classInfoId: this.classInfoId,
          })
          .then((result) => {
            this.chapterMaterialsAttachment = [];
            if (result.data.chapterMaterialsAttachment != null) {
              result.data.chapterMaterialsAttachment.forEach((e) => {
                this.$set(e, "customizeBlock", false);

                this.chapterMaterialsAttachment.push(e);
              });
            }
            if (result.data.chapterMaterialsAttachment != null) {
              result.data.chapterMaterialsListAttachment.forEach((e) => {
                this.$set(e, "customizeBlock", true);
                this.chapterMaterialsAttachment.push(e);
              });
            }
            this.materialsId = result.data.chapterMaterialsId;
            // this.chapterMaterialsAttachment = result.data.chapterMaterialsAttachment;
            this.chapterMaterials = result.data.chapterMaterialsList;
            loading.close();
          })
          .catch((error) => {
            console.log(error);
            loading.close();
          });
      }
    },
    getNoSignInClassInfoStudentList(id) {
      this.signData = {};
      if (this.classInfoId && id > 0) {
        this.api.signInLog
          .getNoSignInClassInfoStudentList({
            classInfoId: this.classInfoId,
            scheduleInfoId: id.toString(),
          })
          .then((result) => {
            this.signData = result.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    materialChange(ids) {
      let obj = {
        attachments: ids,
        type: 1,
        scheduleInfoId: this.scheduleInfoId,
        classInfoId: this.classInfoId,
      };
      this.api.chapterMaterials.addChapterMaterials(obj).then((result) => {
        if (result.success) {
          this.materialDialog = false;
          this.chapterMaterialsList(1);
        } else {
          this.$message.error(result.message);
        }
      });
    },

    handoutsDataSizeChange(pageSize) {
      this.handoutsData.pageSize = pageSize;
      this.getAttachmentList();
    },
    handoutsDataCurrentChange(pageNumber) {
      this.handoutsData.pageNumber = pageNumber;
      this.getAttachmentList();
    },
    optionsChange(val) {
      this.activeName = "签到情况";
      this.scheduleInfoId = "";
      this.ChapterTree = [];
      this.getScheduleSetting(val);
      this.siginTitle = {
        sign: null,
        notsign: null,
        supsign: null,
        statistics: null,
      };
      if (val) {
        this.classInfoId = val;
        this.homeworkData.classInfoId = val;
        this.api.scheduleSetting
          .getPlanNameByClassInfoId({ classInfoId: val })
          .then((res) => {
            if (res.success) {
              this.planName = res.data;
            } else {
              this.$message.error(res.message);
            }
          });
        this.api.signInLog
          .getScheduleInfoListByClassInfoId({ classInfoId: val })
          .then((res) => {
            if (res.success) {
              if (res.data.length != 0) {
                this.ChapterTree = res.data;
                this.scheduleInfoId = res.data[0].id;
                this.homeworkData.scheduleInfoId = res.data[0].id;
              } else {
                this.ChapterTree = [];
                this.scheduleInfoId = undefined;
                this.homeworkData.scheduleInfoId = undefined;
              }
            } else {
              this.$message.error(res.message);
            }
          });
      }
    },

    getAttachmentList(val) {
      this.api.signInLog
        .getAttachmentList({
          objectId: val,
          pageSize: this.handoutsData.pageSize,
          pageNumber: this.handoutsData.pageNumber,
        })
        .then((res) => {
          if (res.success) {
            this.handoutsData.data = res.data;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    handleClick(tab, event) {
      if (!tab) {
        var tab = {
          name: this.activeName,
        };
      }
      if (tab.name == "签到情况") {
        // this.getNoSignInClassInfoStudentList(this.scheduleInfoId);
        this.pageList();
      } else if (tab.name == "课堂练习") {
        this.getPracticeListByScheduleId("1");
      } else if (tab.name == "学习资料") {
        this.chapterMaterialsList("1");
      } else if (tab.name == "课程视频") {
        this.videoParams.scheduleInfoId = this.scheduleInfoId;
        this.getVideoList();
      }
      // else if (tab.name == "直播录播") {
      //   this.getAttachmentList(this.scheduleInfoId);
      // }
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeListByAgentId()
        .then((result) => {
          this.teachingResearchList = [];
          if (result.data.length == 0) {
            this.loading = false;
            this.$message.error("暂无课程信息！");
          } else {
            for (let item of result.data) {
              if (item.children) {
                for (let items of item.children) {
                  if (items.children) {
                    for (let itemss of items.children) {
                      delete itemss.children;
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            this.subjectTreeList = result.data;
            this.courseIds = this.subjectTreeList[0].children[0].children[0].id;
            this.searchForm.courseId =
              this.subjectTreeList[0].children[0].children[0].id;
            this.homeworkData.courseId =
              this.subjectTreeList[0].children[0].children[0].id;
            this.getClassInfoList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    subjectSearchChange() {
      this.searchForm.courseId = this.courseIds[2];
      this.homeworkData.courseId = this.courseIds[2];
      this.scheduleSettingSearchForm.planId = undefined;
      this.getClassInfoList();
      this.options = [];
      this.classInfoId = "";
      this.ChapterTree = [];
      this.scheduleInfoId = "";
      this.signInData.data = [];
      this.siginTitle = {};
    },
    campusSearchChange(e,v) {
     this.chooseId=e[2]
     console.log(e,e[2],this.chooseId,this.treeArr);
     if(this.chooseId){const item=this.treeArr.find(item=>item.id==this.chooseId)
this.campusName=item.name
console.log(this.campusName);}else{
  this.campusName=''
}

      this.getClassInfoList();
      this.options = [];
      this.classInfoId = "";
      this.ChapterTree = [];
      this.scheduleInfoId = "";
      this.signInData.data = [];
      this.siginTitle = {};
      this.scheduleSettingSearchForm.planId = undefined;
    },
    getClassInfoList() {
      let campusId = this.campusId
        ? this.campusId[this.campusId.length - 1]
        : undefined;
      this.api.signInLog
        .getClassInfoList({
          subjectCourseId: this.searchForm.courseId,
          campusId,
        })
        .then((result) => {
          this.options = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openView(url, name) {
      let arr = ["doc", "docx", "xls", "xlsx", "pdf", "ppt"];
      let str = name.toString().split(".");
      console.log(str[str.length - 1]);
      if (arr.indexOf(str[str.length - 1]) != -1) {
        this.viewUrl =
          "https://view.officeapps.live.com/op/view.aspx?src=" + url;
      } else {
        this.viewUrl = url;
      }
      setTimeout(() => {
        this.viewDialog = true;
      });
    },
    signInPageChange(val) {
      let obj = {
        classInfoId: this.classInfoId,
        scheduleInfoId: this.scheduleInfoId,
        pageNumber: val,
        pageSize: this.signInData.pageSize,
        type: this.signType,
      };
      this.pageList(obj);
    },
    signInSizeChange(val) {
      let obj = {
        classInfoId: this.classInfoId,
        scheduleInfoId: this.scheduleInfoId,
        pageNumber: this.signInData.pageNumber,
        pageSize: val,
        type: this.signType,
      };
      this.pageList(obj);
    },
    pageList(params) {
      let self = this;
      if (this.classInfoId && this.scheduleInfoId) {
        if (params == undefined) {
          params = {
            classInfoId: this.classInfoId,
            scheduleInfoId: this.scheduleInfoId,
            pageNumber: this.signInData.pageNumber,
            pageSize: this.signInData.pageSize,
            type: this.signType,
          };
        }
        this.api.signInLog.signList(params).then((res) => {
          if (res.code === 200) {
            this.$forceUpdate();
            this.signInData.data = res.data.student_list;
            this.signInData.total = res.data.total;
            this.signInData.pageNumber = params.pageNumber;
            this.signInData.pageSize = params.pageSize;
            this.siginTitle = res.data.Statistics_list;

            // 要删除代码
            for (let index = 0; index < this.signInData.data.length; index++) {
              if (this.signInData.data[index].student == undefined) {
                this.signInData.data.splice(index, 1);
              }
              // this.signInData.data[index].student.remarks = '签到备注';
            }
            // 以上要删除
          }
          // console.log(res);
        });
        /* this.api.signInLog
          .pageList(obj)
          .then((result) => {
            this.signInData.data = result.data.records;
          })
          .catch((error) => {
            console.log(error);
          }); */
      }
    },
    addDefaultQuestion() {
      this.$confirm("将会添加已录入的标准题库", "提示消息", {
        type: "warning",
      }).then(() => {
        this.api.signInLog
          .copyDefaultChapterMaterials({
            classInfoId: this.classInfoId,
            id: this.scheduleInfoId,
          })
          .then((result) => {
            if (result.success) {
              this.handleClick();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    deleteClassCourseDetail(id) {
      let number = 0;
      this.api.practice.checkPracticeExercise({ id: id }).then((result) => {
        number = result.data;
      });
      this.$confirm(
        number == 0 ? "确定删除吗？" : "该练习已有学员提交,确定删除吗？",
        "系统消息",
        {
          type: "warning",
        }
      ).then(() => {
        this.api.signInLog
          .deleteClassCourseDetail({
            id,
          })
          .then((result) => {
            if (result.success) {
              this.handleClick();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
  },
  watch: {
    activeName() {
      // this.pageList();
    },
    scheduleInfoId() {
      this.handleClick();
    },
  },
  activated() {
    if ((this.activeName = "课后作业")) {
      this.activeName = "签到情况";
      // setTimeout(function(){
      //   this.homeworkBlock = true;
      // console.log("22222222",this.homeworkBlock)
      // },1000)
    }
  },
  created() {},
  mounted() {
    // this.startShowTime()
    // document.getElementById("liveVideo").height =
    //   window.innerHeight - 170 + "px"; // 高度(获取目标网页的高度自适应)
    // document.getElementById("liveVideo").width = window.innerWidth - 540 + "px"; // 宽度(获取目标网页的宽度自适应)});
    this.getSubjectTreeList();
    this.getCampusList();
  },
};
</script>
<style scoped>
.signbtn{
  float:right;
  position: relative;
  top:0.5rem;
  margin-left:0.2rem;
  margin-right:0.3rem;
  z-index:2
}
.signbtn:nth-of-type(1){
  margin-right: 1.7rem;
}
.photoMaterial-button {
  cursor: pointer;
  color: #4d94ff;
  padding: 2px 8px;
  border: 1px solid #4d94ff;
  margin-left: 10px;
  line-height: 22px;
}
.research {
  background-color: #fff;
}
.research .el-card__body {
  height: 100% !important;
}

.research-left {
  width: 20%;
  border-right: 1px solid rgba(238, 238, 238, 1);
  overflow-y: scroll;
}
.research-left::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.tab-type {
  padding: 20px;
  padding-top: 0px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.left-top {
  padding: 0px 20px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 48px;
  line-height: 48px;
}
.left-top-text {
  float: left;
}
.left-top-botton {
  margin-top: 10px;
  float: right;
}
.research-search {
  padding: 0px 20px;
}
.research-select {
  width: 100%;
  margin-top: 20px;
}
.research-tree {
  margin-top: 10px;
  padding-bottom: 20px;
}
.research-icon {
  margin: 0px 10px;
  font-size: 13px;
  color: #409eff;
}
.research-icon-right {
  float: right;
  margin: 10px;
  font-size: 13px;
  color: #409eff;
}
.classRoomButton {
  /* height: 40px;
  width: 50px;
  background-color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 40px;
  color: #fff; */
  font-size: 14px;
  cursor: pointer;
}
.addNote-button {
  height: 32px;
  width: 100px;
  border: 1px solid rgba(77, 148, 255, 1);
  color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 34px;
  cursor: pointer;
}
.videoPlay {
  display: flex;
}
.videoPlay-left {
  width: 75%;
}
.videoPlay-right {
  width: 25%;
  background-color: rgba(246, 249, 250, 1);
  padding: 10px;
}
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-checked
  > .el-tree-node__content {
  background-color: rgb(255, 255, 255);
  color: rgb(64, 158, 255);
}
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: rgb(255, 255, 255);
  color: rgb(64, 158, 255);
}
</style>
<style lang="less">
.research {
  .research-right {
    position: relative;
    overflow-y: scroll;
    width: 80%;
    .signIn {
      width: 100%;
      .signIn-title {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        border: 1px solid #eee;
        padding: 20px 0;
        // background-color: #f00;
        .num-box {
          height: 80px;
          // background-color: #0f0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          .num-num {
            position: relative;
            font-size: 24px;
          }
          .num-title {
            font-size: 14px;
            color: #a2bddf;
          }
        }
        /* .title-left {
          width: 30%;
          border: 1px #dcdfe6 solid;
          height: 80px;
          padding: 20px;
        } */
        /* .title-right {
          border: 1px #dcdfe6 solid;
          padding: 20px;
          height: 80px;
          width: 60%;
        } */
      }
    }
    .custom-tabpane {
      position: absolute;
      top: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 5px;
      width: 150px;
      height: 35px;
      border: 1px solid #c0a199;
      border-radius: 3px;
      z-index: 999999999;
    }
    .studentPreview {
      right: 165px;
    }
  }
  .el-card__body {
    padding: 0px !important;
    height: 100% !important;
  }
  .el-upload-list {
    display: none !important;
  }
  .el-tabs__nav-scroll {
    height: 49px !important;
    line-height: 49px;
  }
  .el-tabs__nav {
    margin-left: 20px;
  }
  .previewBox {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    .el-dialog {
      width: 320px;
      height: 606px;
      margin: inherit;
      border-radius: 50px;
      margin-top: 0 !important;
      .el-dialog__header {
        height: 0;
        width: 0;
        padding: 0;
        opacity: 0;
      }
      .el-dialog__body {
        padding: 0;
        .mobileBg {
          width: 324px;
          height: 606px;
        }
        .content {
          position: relative;
          top: -540px;
          left: 22px;
          width: 280px;
          line-height: 20px;
          font-size: 15px;
          height: 460px !important;
          overflow-y: scroll;
          margin: 0;
          overflow-x: hidden;
          .content-top {
            height: 44px;
            line-height: 44px;
            text-align: center;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
          }
          .content-buttom {
            width: 40px;
            line-height: 28px;
            border: 1px solid rgba(238, 238, 238, 1);
            color: #37aefe;
            text-align: center;
            cursor: pointer;
            position: relative;
            top: -35px;
            left: 225px;
          }
          .attachList {
            margin-bottom: 20px;
            a {
              text-decoration: none;
            }
          }
        }
      }
    }
    img {
      max-width: 100%;
    }
  }
  .jc-sb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .plan-name {
      font-weight: 600;
      color: #455a64;
      margin: 15px 0;
      font-size: 16px;
    }
  }

  .chapterTree-names {
    color: rgb(77, 148, 255) !important;
  }
  .chapterTree-name {
    text-align: center;
    line-height: 20px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    color: #a2aabc;
    white-space: nowrap;
    overflow: hidden;
    text-indent: 2px;
    text-overflow: ellipsis;
    cursor: pointer;
    &:hover {
      color: rgb(77, 148, 255);
    }
  }
  // .research-tree {
  //   padding-bottom: 0px;
  //   .el-tree-node__label {
  //     font-size: 13px;
  //     color: #a2aabc;
  //   }
  // }
  // .el-tree-node:focus > .el-tree-node__content {
  //   color: #409EFF;
  // }
  .dashboard-show-data {
    height: 470px;
    border: solid 2px rgb(246, 246, 246);
    background: #fff;
    margin-top: 20px;
    padding: 10px 10px 0px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/index.vue